'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Modal;
(function (Modal) {
    var MyModal = /** @class */ (function () {
        function MyModal() {
            var _this = this;
            $('.trigMovieButton').on('click', function (e) {
                var movieId = $(e.currentTarget).attr('data-movie-id');
                var movieHTML = '<iframe src="https://www.youtube.com/embed/' + movieId + '" allow="ceaclerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
                $('.bulletModalContent').html(movieHTML);
                $('.bulletModalContent').attr('data-flag', 'movie');
                _this.modalOpen();
            });
            $('.trigModalPoster').on('click', function (e) {
                var url = $(e.currentTarget).attr('data-url');
                var imgHTML = '<p class="modal__box__content__img" style="background-image: url(' + url + ')"></p>';
                $('.bulletModalContent').html(imgHTML);
                $('.bulletModalContent').attr('data-flag', 'image');
                _this.modalOpen();
            });
            $('.trigCloseModalWindow').on('click', function () {
                $('#bulletModalWindow').attr('data-open', 'false');
            });
        }
        MyModal.prototype.modalOpen = function () {
            var isModalOpen = $('.paramModalWindow').attr('data-open');
            if (isModalOpen == 'false') {
                $('#bulletModalWindow').attr('data-open', 'true');
            }
            else {
                $('#bulletModalWindow').attr('data-open', 'false');
            }
        };
        return MyModal;
    }());
    Modal.MyModal = MyModal;
})(Modal || (Modal = {}));
exports.default = Modal;
